import React, { useState, useEffect } from "react"

const GetTAF = function (aerodromeICAO, url) {

  console.log(aerodromeICAO, url)

  const [tafs, setTAFs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const tafsUrl = [
    "https://awiacja.imgw.pl/en/taf-military-airports/",
    "https://awiacja.imgw.pl/en/taf-ft-2/",
    "https://awiacja.imgw.pl/en/taf-fc-2/"
  ];

  useEffect(() => {
    fetchTAF(aerodromeICAO, url)
  }, [])

  const fetchTAF = async (icao, link) => {

    fetch(tafsUrl[link])
      .then(response => {
        if (response.ok) {
          return response.text();
        }
        throw response
      })
      .then(data => {

        const feed = new window.DOMParser().parseFromString(data, "text/html");
        let tafDiv = feed.getElementsByClassName("taftext")[0].innerHTML;

        tafDiv = tafDiv.replace(/<[^>]*>?/gm, ''); //remove html tags
        tafDiv = tafDiv.replace(/\s+/g, ' ').trim(); // remove duplicated space

        let tafsArray = tafDiv.split("=");
        tafsArray.pop();
        tafsArray = tafsArray.map(i => i = i + "=");
        // console.log("tafsArray ", tafsArray)

        if (typeof icao !== 'undefined' && icao.length > 0) {
          var PATTERN = new RegExp(icao, "g");
          const filtered = tafsArray.filter(function (str) { return PATTERN.test(str); });
          console.log("filtred by:", icao, filtered); // [{name: 'Lea', country: 'Italy'}]

          if (typeof filtered !== 'undefined' && filtered.length > 0) {
            setTAFs(filtered);
          } else {
            let res = `Brak depesz TAF dla ${icao}`;
            setTAFs(res);
          }
        }
      })
      .catch(error => {
        console.error("Error: ", error);
        setError(error);

      })
      .finally(() =>
        setLoading(false));
  }
  if (loading) return "Pobieram..."
  if (error) return "Błąd";


  return (
    <div className="taf">
      {tafs}
    </div>

  );

}

export default GetTAF